<template>
  <section id="skills" class="skills-section">
    <div class="section-header">
      <h2 class="section-title">技能中心</h2>
      <p class="section-subtitle">探索专业 AI 技能，赋能你的应用</p>
    </div>
    <div class="skills-grid">
      <SkillCard
        v-for="skill in skillsStore.list"
        :key="skill.id"
        :title="skill.skillName"
        :description="skill.description"
        :features="parseFeatures(skill.customTags)"
        :icon-type="skill.iconType"
        :active="Boolean(skill.enabled)"
        :version="skill.version"
        @click="handleSkillClick(skill)"
      />
    </div>
    <SkillModal
      :visible="modalVisible"
      :title="selectedSkill?.skillName"
      :description="selectedSkill?.description"
      :features="parseFeatures(selectedSkill?.customTags)"
      :icon-type="selectedSkill?.iconType"
      :version="selectedSkill?.version"
      :install-script="selectedSkill?.installScript"
      @close="closeModal"
    />
  </section>
</template>

<script setup>
  import { ref } from 'vue'
  import { onMounted } from 'vue'
  import { useSkillsStore } from '@/store/modules/skills'
  import SkillCard from './SkillCard.vue'
  import SkillModal from './SkillModal.vue'

  const skillsStore = useSkillsStore()

  const modalVisible = ref(false)
  const selectedSkill = ref(null)

  onMounted(() => {
    skillsStore.fetchList()
  })

  const parseFeatures = (features) => {
    if (!features) return []
    if (Array.isArray(features)) return features
    return features
      .split(',')
      .map((f) => f.trim())
      .filter((f) => f)
  }

  const handleSkillClick = (skill) => {
    if (skill.enabled) {
      selectedSkill.value = skill
      modalVisible.value = true
    }
  }

  const closeModal = () => {
    modalVisible.value = false
    selectedSkill.value = null
  }
</script>

<style scoped>
  .skills-section {
    position: relative;
    z-index: 10;
    padding: 100px 32px;
  }

  .section-header {
    text-align: center;
    max-width: 700px;
    margin: 0 auto 60px;
  }

  .section-title {
    font-size: clamp(32px, 5vw, 48px);
    font-weight: 900;
    color: var(--text-primary);
    margin-bottom: 16px;
    letter-spacing: -0.02em;
  }

  .section-subtitle {
    font-size: 18px;
    color: var(--text-secondary);
  }

  .skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .skills-section {
      padding: 60px 20px;
    }

    .skills-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
